// extracted by mini-css-extract-plugin
export default {"delay":"solutions_delay__feykx","hero":"solutions_hero__T7Iix","solutions":"solutions_solutions__bmwV4"};